import React from 'react';

export interface CSidebarButtonBaseProps {
  children: JSX.Element | string;
  onClick?: () => void;
  stopPropagation?: boolean;
  startIcon?: {
    default: JSX.Element;
    selected?: JSX.Element;
  }
  endIcon?: {
    default: JSX.Element;
  }
  isActive?: boolean;
  indent?: boolean;
}

export default function CSidebarButtonBase(props: CSidebarButtonBaseProps) {
  return (
    <div className={'relative flex overflow-hidden hover:cursor-pointer rounded-xl'}
         style={{background: props.isActive ? 'rgb(255, 137, 69)' : 'inherit', color: props.isActive ? 'white' : 'inherit'}}
         onClick={(ev) => {
           props.stopPropagation && ev.stopPropagation();
           props.onClick?.();
         }}>
      <div className={'flex gap-3 py-2 px-3 items-center z-10 hover:bg-teal hover:text-white font-normal flex-nowrap flex-grow'} style={{width: '13.5rem'}}>
        {props.indent && <div className={'w-6 sidebar-indent'}/>}
        {props?.startIcon && <span className={'w-6 h-8 flex relative'}>{props.startIcon.selected && props.isActive ? props.startIcon.selected : props.startIcon.default}</span>}
        <h6 className={'text-xl whitespace-nowrap overflow-hidden flex-grow text-inherit'}>
          {props.children}
        </h6>
        {props?.endIcon && <div className={'w-6 h-8 flex items-center relative'}>{props.endIcon.default}</div>}
      </div>
    </div>
);
}
